// extracted by mini-css-extract-plugin
export default {"container":"DescriptionsModal_container__uMWi0","text":"DescriptionsModal_text__j-T7+"};